import { admin, custom, departments, externalTypes, services } from "data/authData";

const buildRoleLabelMap = () => {
	const map = { [admin]: "Admin" };
	[departments, services, custom, externalTypes].forEach((group) => {
		Object.values(group || {}).forEach((item) => {
			if (item?.key) map[item.key] = item.name || item.key;
		});
	});
	return map;
};

export const roleLabelMap = buildRoleLabelMap();

export const getRoleLabel = (key) => roleLabelMap[key] || String(key || "").replace(/_/g, " ");

export const getRoleKeys = (role) => Object.keys(role || {}).filter(Boolean);
